export enum TimePeriod {
    Day,
    Week,
    Month,
    Period
}